/* RESPONSIBLE TEAM: team-fin-qa */
import ApplicationSerializer from '../application';

/**
 * Normalizes the /ai_insights/topics response into subtopic records.
 * The API returns { topics: [{ topicName, subtopicId, subtopicName }, ...] }.
 * Each entry becomes a subtopic record with subtopicId as ID.
 */
export default class AiSubtopicSerializer extends ApplicationSerializer {
  normalizeArrayResponse(
    store: any,
    primaryModelClass: any,
    payload: any,
    id: any,
    requestType: any,
  ) {
    let topics: any[] = payload.topics || [];
    let normalized = topics.map((t: any) => ({
      id: String(t.subtopic_id),
      name: t.subtopic_name,
      topic_name: t.topic_name,
    }));
    return super.normalizeArrayResponse(store, primaryModelClass, normalized, id, requestType);
  }
}
